import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation UpdateRowItem($companyId: ID!, $id: ID!, $attributes: RowItemAttributes!) {
    updateRowItem(companyId: $companyId, id: $id, attributes: $attributes) {
      rowItem {
        id
        ...UpdatedRowItem
      }
      errors {
        path
        message
      }
    }
  }

  fragment UpdatedRowItem on RowItem {
    id
    name
    priceCents
  }
`
